import { WORKFLOW_STATUS } from './../constants/index';
import { makeObservable, observable, runInAction, action } from 'mobx'
import { Workflow, WorkflowStatus } from './types'
import axios from '../../axios'
import Axios, { AxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'
export class WorkflowStore {
  loadingList: boolean = false
  list: Workflow[] = []
  totalPages: number = 0
  totalElements: number = 0
  nodeData: any = [{}]
  flag: boolean = false;
  cancelTokenSource = () => {}
  entries: {
    [key: string]: Workflow
  } = {}

  constructor() {
    makeObservable(this, {
      loadingList: observable,
      list: observable,
      entries: observable,
      nodeData: observable,
      flag: observable,
      getData: action,
      delete: action,
      updateWorkflowWithStatus: action,
    })
  }

  reset = () => {
    this.clearList()
    this.entries = {}
    this.cancelTokenSource = () => {}
  }

  save = (data: Workflow) => {
    return axios.post("/prediction-services/api/v1/workflow", data).then(({data}) => {
      toast.success(
        'Successfully saved the workflow. You can now start the workflow.'
      )
      return data;
    });
  } 

  getData = (filters: any = {}) => {
    if (typeof this.cancelTokenSource == 'function') {
      // this.cancelTokenSource()
    }

    if (filters.withIdsFilter && !filters.ids) {
      this.clearList()
      return
    }

    const cancelTokenSource = Axios.CancelToken.source()

    const params: any = {
      ...filters,
      name: filters.searchValue,
      access_filter: filters.sharingStatus,
    }
    delete params.searchValue
    delete params.ownership
    delete params.sharingStatus

    this.setLoadingList(true)

    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
      params,
    }
    axios
      .get(`/prediction-services/api/v1/workflow`, config)
      .then(({ data }) => {
        if (data?.content) {
          runInAction(() => {
            data.content.forEach((workflow: Workflow) => {
              this.setWorkflow(workflow)
            });
            this.list = data.content
            this.totalPages = data.totalPages
            this.totalElements = data.totalElements
          })
        }
      })
      .catch(() => {
        this.clearList()
      })
      .finally(() => {
        this.setLoadingList(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }


  getDataById = async (id: number) => {
    return await axios.get(`/prediction-services/api/v1/workflow?ids=${id}`).then(({data}) => {
      this.setWorkflow(data?.content)
      return data;
    })
  };

  update = async (data: Workflow, id: number) => {
    return await axios.put(`/prediction-services/api/v1/workflow/${id}`, data).then((response) => {
      this.setWorkflow(data);
      toast.success('Updated successfully')
      return response
    })
  }


  delete = async (id: number) => {
    return await axios.delete('/prediction-services/api/v1/workflow?id='+ id).then(({data}) => {
      this.setWorkflow(data);
      toast.success('Deleted successfully')
      this.deleteDataFromList(id);
      return data
    })
  }


  setWorkflow = (workflow: Workflow) => {
    const index = this.list.findIndex((item: Workflow) => item.id === workflow.id)
    if (index !== -1) {
      this.list[index] = workflow
    }
    this.entries[`${workflow.id}`] = workflow
  }



  clearList = () => {
    this.loadingList = false
    this.list = []
    this.totalPages = 0
    this.totalElements = 0
  }

  setLoadingList = (value: boolean) => {
    this.loadingList = value
  }

  deleteDataFromList = (id: number) => {
    const index = this.list.findIndex((item: Workflow) => item.id === id)
      this.list.splice(index, 1);
  }

  runWorkflow = (id: number) => {
    return axios.post('/prediction-services/api/v1/workflow/run?id='+id).then((data) => {
      toast.success('Workflow is running.')
      this.updateWorkflowWithStatus(id, WORKFLOW_STATUS.RUNNING as WorkflowStatus)
      return data
    });
   }

   cancel = async (id: number) => {
    return await axios
      .post(
        `/prediction-services/api/v1/workflow/${id}/update/status?status=${WORKFLOW_STATUS.CANCELLED}`
      )
      .then((response) => {
        toast.warning('Workflow cancelled.')
        this.updateWorkflowWithStatus(id, WORKFLOW_STATUS.CANCELLED as WorkflowStatus)
        return response
      })
   }

   updateWorkflowWithStatus = async (id: number, status: WorkflowStatus) => {
    const index = this.list.findIndex((item: Workflow) => item.id === id)
    const workflow = this.list[index];
    workflow.status = status;
    this.entries[`${workflow.id}`] = workflow
   }

}

export const workflowStore = new WorkflowStore()
